export default "__VITE_ASSET__DoufpoxS__"